import "react";
import { combineClasses as s } from "../../utils/combineClasses.mjs";
import "react-nanny";
const f = (t, r, e) => r ? s("category-open", e) : t ? s("category-active", e) : e, l = (t, r, e) => {
  if (t.current) {
    const o = t.current;
    e ? o == null || o.set(r, e) : o == null || o.delete(r);
  }
}, u = (t, r) => {
  [...t.current.values()][r].focus();
}, g = (t) => t.offsetX > t.target.clientWidth || t.offsetY > t.target.clientHeight;
export {
  u as focusOnObject,
  f as getCategoryClasses,
  g as isBrowserScrollBarClicked,
  l as registerChildRef
};
